import React from 'react';
import type { DeliverableStatus } from '../types/portal';
import { clientStatusLabel, isReviewable } from '../utils/deliverables';
interface StatusTagProps {
  status: DeliverableStatus;
  /** Client wording, Portal's internal wording, or the review-page wording. */
  audience?: 'client' | 'portal' | 'review';
}
function labelFor(status: DeliverableStatus, audience: 'client' | 'portal' | 'review'): string {
  if (audience === 'portal') return status.toUpperCase();
  return clientStatusLabel(status);
}
export function StatusTag({
  status,
  audience = 'client'
}: StatusTagProps) {
  const attention = isReviewable(status);
  const settled = status === 'Approved' || status === 'Delivered' || status === 'Ready for Download';
  return <span className={['label inline-flex items-center whitespace-nowrap border px-2.5 py-1.5', attention ? 'border-ink bg-ink text-paper' : settled ? 'border-graphite/40 text-graphite' : 'border-rule text-mute'].join(' ')} data-id="element-412" data-mp="2millf5ykz66j">
      {labelFor(status, audience)}
    </span>;
}